import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

type Param = {
    onSubmit: () => void,
    disabled?: boolean
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        minWidth: 300,

        // xs (max-width: 599.95px)
        [theme.breakpoints.down('xs')]: {
            minWidth: 150,
        },

        borderRadius: 0,
        fontSize: 17
    },

    endIcon: {
        height: 'auto',
        width: 17
    }
}));


const BtnNavNext: React.FC<Param> = ({ onSubmit, disabled }) => {
    const classes = useStyles();

    return <>
        <Button
            type='submit'
            title="Weiter"
            variant="contained"
            color="secondary"
            size="large"
            disabled={disabled}
            onClick={onSubmit}
            classes={{ root: classes.root }}
            endIcon={<ArrowForwardIosIcon classes={{ root: classes.endIcon }} />}>
            Weiter
        </Button>
    </>
        ;
}

export default BtnNavNext;